import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-929b0cc6")

_pushScopeId("data-v-929b0cc6")
const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "仮登録患者様一覧", -1)
const _hoisted_2 = { class: "card-list" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "no-match-card" }, "仮登録患者とはマッチさせずに登録する", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_radio_button_card = _resolveComponent("radio-button-card")
  const _component_key_value_frame = _resolveComponent("key-value-frame")
  const _component_vue_y_scroll_area = _resolveComponent("vue-y-scroll-area")
  const _component_vue_content = _resolveComponent("vue-content")

  return (_openBlock(), _createBlock(_component_vue_content, { class: "vue-content-remain-child" }, {
    default: _withId(() => [
      _hoisted_1,
      _createVNode(_component_vue_y_scroll_area, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_radio_button_card, {
              selected: _ctx.selectedTemporaryId==='no-match',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedTemporaryId='no-match'))
            }, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["selected"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.temporaryPatientInfos, (temp) => {
              return (_openBlock(), _createBlock(_component_radio_button_card, {
                key: temp.temporary.id,
                selected: _ctx.selectedTemporaryId===temp.temporary.id,
                onClick: ($event: any) => (_ctx.selectedTemporaryId = temp.temporary.id)
              }, {
                default: _withId(() => [
                  _createVNode(_component_key_value_frame, {
                    class: "temporary-list-content",
                    items: temp.info
                  }, null, 8, ["items"])
                ]),
                _: 2
              }, 1032, ["selected", "onClick"]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})